<template>
    <div>
        <div class="d-flex flex-column gap-2 question-container"
             v-for="(question,idx) in this.template.questions"
             :key="idx">
            <div>Question {{idx+1}}</div>
            <div>{{question['question']}}</div>
            <div class="d-flex gap-3">
                <div v-for="(a,index) in question.answers" class="d-flex gap-3">
                    <input :id="'tf-'+idx+'-'+index"
                           type="radio"
                           :name="'trueFalse-'+idx"
                           :value="true"
                           v-model="a.is_correct"
                           class="form-check-input"/>
                    <label :for="'tf-'+idx+'-'+index" class="form-check-label">{{typeof a.value === "object" ? a.value[0] : a.value}}</label>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'trueOrFalse-component',
        data() {
            return {}
        },
        async mounted() {
            if (process.env.VUE_ENV === 'development')
            console.log('this.template -> ',this.template)
        },
        props: ['template'],
        methods: {
        }
    }
</script>

<style scoped>
    .question-container {
        border-bottom: 1px solid #e65c00;
        margin-bottom: 10px;
        padding-bottom: 10px;
    }

    .question-container:last-child {
        border-bottom: none;
    }

    .form-check-input {
        border: 1px solid #e95626 !important;;
        background-color: transparent !important;
    }

    .form-check-input:checked {
        background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e") !important;
        border: 2px solid var(--border-color-data-table) !important;;
        background-color: #e95626 !important;
        box-shadow: 0 0 0 1px #e95626 !important;
    }
    input{
        pointer-events: none;
    }

    label{
        pointer-events: none;
    }
</style>